import { useMutation, useQueryClient } from '@tanstack/react-query'

import api from '../../api'
import { AddAdGroupMemberRequest } from '../../types/active-directory'

const useAddAdGroupMember = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (addAdGroupMemberRequest: AddAdGroupMemberRequest) => {
			return api.activeDirectory.addAdGroupMember(addAdGroupMemberRequest)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['AllAdGroups']
			})
		}
	})
}

export default useAddAdGroupMember
